/** @format */

import React, { useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import GridItem from '../../../components/Grid/GridItem';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import SimCard from '@material-ui/icons/SimCard';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import { ImsiView } from './ImsiView';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import { iccidState } from '../../../helpers/iccidStatus';
import { ImsiSimCardChangeMsisdn } from './ImsiSimCardChangeMsisdn';
import { ImsiSimCardParringOperation } from './ImsiSimCardParringOperation';
import ImsiHistory from './ImsiHistory';

type ImsiDetailType = {
    handleSetBrandText: (text: string) => void;
};

export const ImsiDetail = ({ handleSetBrandText }: ImsiDetailType): React.ReactElement => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [imsiItem, setImsiItem] = useState<PlatformIccidPoolNumber | null>(null);

    useEffect(() => {
        const itemLoader = new ItemLoaders(dispatch);
        if (!imsiItem) {
            itemLoader.getWithCallback(
                FormGeneralHelper.getByUri('/' + id),
                'imsi_detail_details_view_get',
                (data: PlatformIccidPoolNumber) => {
                    setImsiItem(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        }
        handleSetBrandText('pools:sim.sim_card');
    }, [dispatch, id, handleSetBrandText, imsiItem]);

    const reloadPage = (): void => setImsiItem(null);

    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={6}>
                <Card>
                    <CardHeader icon={<SimCard />} trans="pools:sim.sim_card" />
                    <CardBody>{imsiItem && <ImsiView reload={reloadPage} item={imsiItem} />}</CardBody>
                </Card>
            </GridItem>
            <GridItem xs={6}>
                {imsiItem &&
                    imsiItem.iccidState === iccidState.USED &&
                    imsiItem.simCard &&
                    UserRoleHelper.checkRole(roles.ROLE_PLATFORM_CHANGE_MSISDN) && <ImsiSimCardChangeMsisdn simCardUri={imsiItem.simCard} />}
                {imsiItem && imsiItem.iccidState !== iccidState.USED && UserRoleHelper.checkRole(roles.ROLE_PLATFORM_SIMCARD_POST) && (
                    <ImsiSimCardParringOperation imsiItem={imsiItem} reloadPage={reloadPage} />
                )}
            </GridItem>
            {imsiItem && (
                <React.Fragment>
                    <GridItem xs={12} md={12}>
                        <ImsiHistory imsi={imsiItem} />
                    </GridItem>
                </React.Fragment>
            )}
        </GridContainer>
    );
};
